import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  ref: "modalContent",
  class: "OverlappingCampaignsModal"
}
const _hoisted_2 = {
  key: 0,
  class: "OverlappingCampaignsDetailedList"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_OverlappingCampaignsList = _resolveComponent("OverlappingCampaignsList")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("h2", null, [
      _createElementVNode("i", { class: "lnr-notification-circle" }),
      _createTextVNode(" Your changes could not be saved ")
    ], -1 /* CACHED */)),
    _cache[1] || (_cache[1] = _createElementVNode("p", null, [
      _createTextVNode(" The changes that you are trying to save create one or more "),
      _createElementVNode("em", null, "conflicts with other campaigns:")
    ], -1 /* CACHED */)),
    (_ctx.overlappingCampaignsCluster)
      ? (_openBlock(), _createElementBlock("ul", _hoisted_2, [
          _createVNode(_component_OverlappingCampaignsList, {
            entityName: "Organisation",
            entities: _ctx.overlappingCampaignsCluster.duplicateOrganisations
          }, null, 8 /* PROPS */, ["entities"]),
          _createVNode(_component_OverlappingCampaignsList, {
            entityName: "Study",
            entities: _ctx.overlappingCampaignsCluster.duplicateStudies
          }, null, 8 /* PROPS */, ["entities"])
        ]))
      : _createCommentVNode("v-if", true)
  ], 512 /* NEED_PATCH */))
}